import app from './app';

window.onload = () => {
  app();
};
